/* eslint-disable @typescript-eslint/naming-convention */
export enum messageSeverityEnum {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'error',
    noContent = 'noContent',
    noContentDark = 'noContentDark',
    noContentPale = 'noContentPale',
    noContentLarge = 'noContentLarge',
    noStaff = 'noStaff'
}
